const Books = require("./data/dbOnlineBooks.json");
const GradeChapter = require("./GradeChapter");
const dbDemoData = require("./data/dbDemoData.json");

const _ = require("lodash");

const getChapterPages = function(chapterID, demo) {
	if (chapterID === 0) {
		return [0, 0];
	}
	return demo
		? dbDemoData.chapterPages[chapterID]
		: Books.chapterPages[chapterID];
};

const getChapterLength = function(chapterID, demo) {
	const chapterPages = getChapterPages(chapterID, demo);
	return chapterPages[1] - chapterPages[0] + 1;
};

const getChapterSections = function(chapterID, demo) {
	return demo
		? dbDemoData.chapterSections[chapterID]
		: Books.chapters[chapterID];
};

const getSectionData = function(sectionID) {
	return Books.sections[sectionID];
};

const getBookHash = function(chapterID) {
	return _.findKey(Books.books, chapters => {
		return chapters.indexOf(chapterID) > -1;
	});
};

const getChapterName = function(chapterID) {
	const context = GradeChapter.chapterIDToContext(chapterID);
	return context ? context.name : "";
};

const getChapterNameFromContext = ({gradeNumber, chapterIndex}) => {
	const chapterID = GradeChapter.toChapterID(gradeNumber, chapterIndex);
	return getChapterName(chapterID);
};

const getIDsFromNumbers = function(context, demo) {
	const chapterID = GradeChapter.toChapterID(
		context.gradeNumber,
		context.chapterIndex
	);
	if (!chapterID) return null;
	const sectionID = _.get(context, "demo")
		? dbDemoData.chapterSections[chapterID][0]
		: Books.chapters[chapterID][context.sectionIndex];
	return {chapterID, sectionID};
};

const getSectionIDFromContext = function(context, demo) {
	const ids = getIDsFromNumbers(context, demo);
	return ids && ids.sectionID;
};

const getSectionIDFromChapterPage = function(chapterID, pageNumber, demo) {
	if (demo) {
		const sections = dbDemoData.chapterSections[chapterID];
		return sections ? sections[0] : null;
	}

	const sections = _.pick(Books.sections, getChapterSections(chapterID), demo);

	const sectionID = _.findKey(sections, sd =>
		_.inRange(pageNumber, sd.page[0], sd.page[1] + 1)
	);
	// If not a section (i.e. title page), return 0
	return parseInt(sectionID) || 0;
};

const getSectionsInPageRange = function(chapterID, pageRange) {
	const sectionsInPageRange = new Set();
	for (let i = pageRange[0]; i <= pageRange[1]; i++) {
		sectionsInPageRange.add(getSectionIDFromChapterPage(chapterID, i));
	}
	return [...sectionsInPageRange];
};

const getSectionIndexFromSectionID = function(sectionID) {
	const chapterID = _.findKey(Books.chapters, ch => _.includes(ch, sectionID));
	if (!chapterID) return null;
	return Books.chapters[chapterID].indexOf(sectionID);
};

const getChapterIDFromSectionID = function(sectionID) {
	const chapterID = _.findKey(Books.chapters, ch => _.includes(ch, sectionID));
	return chapterID || null;
};

const getContextFromSectionID = function(sectionID, demo) {
	const chapterID = getChapterIDFromSectionID(sectionID);
	if (!chapterID) return null;
	const sectionIndex = demo ? 0 : Books.chapters[chapterID].indexOf(sectionID);
	const context = GradeChapter.chapterIDToContext(chapterID);
	return {
		gradeNumber: context.gradeNumber,
		chapterIndex: context.chapterIndex,
		sectionName: Books.sections[sectionID].name,
		sectionIndex,
	};
};

const getChapterSectionPages = function(sectionID) {
	const sectionData = getSectionData(sectionID);
	return _.get(sectionData, "page");
};

module.exports = {
	getChapterPages,
	getChapterLength,
	getChapterSections,
	getSectionData,
	getBookHash,
	getChapterName,
	getChapterNameFromContext,
	getIDsFromNumbers,
	getSectionIDFromChapterPage,
	getSectionsInPageRange,
	getSectionIndexFromSectionID,
	toChapterID: GradeChapter.toChapterID,
	getSectionIDFromContext,
	getChapterIDFromSectionID,
	getContextFromSectionID,
	getChapterSectionPages,
};
